<template>
  <div class="staff-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="tableLoading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="dName"
                    label="姓名"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="dUsername"
                    label="电话"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="130">
                    <template slot-scope="scope">
                      <div v-if="scope.row.dUsername===''">
                        未填写
                      </div>
                      <div v-else>
                        {{scope.row.dUsername}}
                      </div>
                    </template>
                  </el-table-column>
                  <!--<el-table-column
                    prop="spec"
                    label="性别"
                    align="center"
                    width="80">
                    <template slot-scope="scope">
                      <el-tag size="small" v-if="scope.row.dSex==='男'">男</el-tag>
                      <el-tag type="danger" size="small" v-if="scope.row.dSex==='女'">女</el-tag>
                      <el-tag size="small" type="info" v-if="scope.row.dSex===''">无</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="dWchat"
                    align="center"
                    label="微信"
                    :show-overflow-tooltip="true"
                    width="130">
                    <template slot-scope="scope">
                      <div v-if="scope.row.dWchat===''">
                        未填写
                      </div>
                      <div v-else>
                        <svg-icon icon-class="wechat" style="color:#606266;width: 13px;" />
                        {{scope.row.dWchat}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="dEmail"
                    label="Email"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="180">
                    <template slot-scope="scope">
                      <div v-if="scope.row.dEmail===''">
                        未填写
                      </div>
                      <div v-else>
                        <i class="el-icon-message"/> {{scope.row.dEmail}}
                      </div>
                    </template>
                  </el-table-column>-->
                  <el-table-column
                    prop="group_abbname"
                    align="center"
                    label="公司">
                    <template slot-scope="scope">
                       {{scope.row.group_abbname}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="dept_name"
                    label="部门"
                    :show-overflow-tooltip="true"
                    align="center">
                    <template slot-scope="scope">
                      {{scope.row.dept_name}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="position_name"
                    label="职位"
                    :show-overflow-tooltip="true"
                    align="center">
                    <template slot-scope="scope">
                      {{scope.row.position_name}}
                    </template>
                  </el-table-column>
                  <!--<el-table-column
                    align="center"
                    label="地址"
                    width="170">
                    <template slot-scope="scope">
                      <div v-if="scope.row.dProvince===''&&scope.row.dCity===''&&scope.row.dCounty===''">未填写</div>
                      <div v-if="scope.row.dProvince!==''&&scope.row.dCity===''&&scope.row.dCounty===''">
                        <i class="el-icon-location"/> {{scope.row.dProvince}}
                      </div>
                      <div v-if="scope.row.dProvince!==''&&scope.row.dCity!==''&&scope.row.dCounty===''">
                        <i class="el-icon-location"/> {{scope.row.dProvince}}/{{scope.row.dCity}}
                      </div>
                      <div v-if="scope.row.dProvince!==''&&scope.row.dCity!==''&&scope.row.dCounty!==''">
                        <i class="el-icon-location"/> {{scope.row.dProvince}}/{{scope.row.dCity}}/{{scope.row.dCounty}}
                      </div>
                    </template>
                  </el-table-column>-->
                  <el-table-column
                    align="center"
                    label="操作"
                    width="180">
                    <template slot-scope="scope">
                      <el-button @click="getRow(scope.row,1)" icon="el-icon-check" size="mini">通过</el-button>
                      <el-button @click="getRow(scope.row,0)" icon="el-icon-close" size="mini">拒绝</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getUser } from '@/utils/auth'
  import { getUserList} from '@/api/work'
  import { checkRegisterUser} from '@/api/work'

  export default {
    computed: {
      user: getUser
    },
    created() {
      this.getUserList();
    },
    data(){
      return{
        searchForm: {
          search: ''
        },
        tableData: [],
        tableLoading: false,
        total: 0,
        pageSize: 20,
        currentPage: 1,
        staffDetail: {},
        typeFilter: 1
      }
    },
    methods:{
      getUserList(){
        this.tableLoading = true
        const data = {
          keyword: this.searchForm.search,
          page: this.currentPage,
          limit: this.pageSize,
          type: 2,
          groupId: this.user.dGroupid,
          issh: 1
        }
        getUserList(data).then(response => {
          this.tableData = response.data
          this.total = response.total
          this.tableLoading = false
        })
      },
      change(n){
        this.typeFilter = n
        this.currentPage = 1
        this.getUserList()
      },
      //搜索
      Search(){
        this.currentPage = 1
        this.getUserList()
      },
      handleSizeChange(val){
        this.currentPage = 1
        this.pageSize = val
        this.getUserList()
      },
      handleCurrentChange(val){
        this.currentPage = val
        this.getUserList()
      },
      getRow(row,type){
        let title = '您确定将'+row.dName+'列为公司员工吗？'
        if(type===0){
          title = '确定后'+row.dName+'将不能成为公司员工'
        }
        this.$confirm(title, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          checkRegisterUser({userid: row.dUserid,type: type}).then(response=>{
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.getUserList()
          })
        }).catch(() =>{

        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .staff-container {
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          font-weight: 500;
          color: #404852;
          margin-bottom: 22px;
          font-size: 14px;
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
</style>
